import gql from "graphql-tag";

export const CREATE_ALL_APPROVAL_BY_EXAMINER = gql`
  mutation createAllApprovalByExaminer($contractCodes: [String!]!) {
    createAllApprovalByExaminer(contractCodes: $contractCodes)
  }
`;
